module.exports = __webpack_public_path__ + "img/08-769b07.png";